export const DEFAULT_MAX_PRICE = 99999999;